import React from "react";

export default function RedditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
    >
      <path
        fill="currentColor"
        d="M9.25 12.082c-.687 0-1.245.558-1.245 1.246 0 .687.558 1.26 1.246 1.246a1.247 1.247 0 0 0 0-2.492ZM12.014 17.552c.473 0 2.105-.057 2.965-.916a.349.349 0 0 0 0-.459.32.32 0 0 0-.459 0c-.53.545-1.69.73-2.506.73-.816 0-1.961-.185-2.506-.73a.32.32 0 0 0-.458 0 .32.32 0 0 0 0 .459c.845.845 2.477.916 2.964.916ZM13.504 13.342c0 .688.558 1.246 1.245 1.246.688 0 1.246-.573 1.246-1.246a1.247 1.247 0 0 0-2.491 0Z"
      />
      <path
        fill="currentColor"
        d="M24 12.082c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12Zm-5.742-1.747c-.473 0-.902.186-1.217.487-1.203-.86-2.85-1.418-4.683-1.49l.802-3.751 2.606.558a1.245 1.245 0 0 0 2.492-.057c0-.687-.559-1.246-1.246-1.246-.487 0-.916.287-1.117.702l-2.907-.616a.305.305 0 0 0-.229.043.279.279 0 0 0-.129.2l-.888 4.182c-1.861.057-3.537.616-4.754 1.49a1.76 1.76 0 0 0-1.217-.488 1.745 1.745 0 0 0-.716 3.337 3.177 3.177 0 0 0-.043.53c0 2.692 3.136 4.883 7.002 4.883 3.867 0 7.003-2.177 7.003-4.883a3.31 3.31 0 0 0-.043-.53 1.764 1.764 0 0 0 1.03-1.604c0-.974-.787-1.747-1.746-1.747Z"
      />
    </svg>
  );
}
